const Translation = {
  en: {
    title: "NCW Sahayika- Your Digital AI Assistant",
    suggestedQuestionsText: "Suggested Questions",
    suggestedQuestions: [
      "I am facing sexual harassment at my corporate workplace by a senior manager, and the company Internal Complaints Committee (ICC) is refusing to process my complaint.",
      "I went to report domestic violence and dowry harassment, but the police officer on duty refused to register an FIR and misbehaved with me.",
      "Women commuters in our locality face daily verbal harassment and stalking at public bus stops due to non-functional streetlights and lack of security.",
      "Our company is forcing female employees to work late-night shifts without providing mandatory cab drop facilities or female security guards.",
      "Someone is cyberstalking me online and sharing manipulated photos on social media platforms to harass and blackmail me.",
      "My in-laws are subjecting me to severe physical domestic abuse and demanding dowry, and I urgently need shelter at a Sakhi Niwas / One Stop Centre.",
      "My spouse married me in India and deserted me overseas, withholding financial support and personal documents.",
    ],
    faqTitle: "Ask your query",
    faqScroller:
      "This assistant provides guidance and answers queries related to NCW services",
    botScroller:
      "This assistant provides a simple way to submit complaints and track status of previously submitted requests",
    suggestedFAQs: [
      "What is NCW?",
      "What powers does the NCW have?",
      "How does NCW perform its role?",
      "How can I file a POSH complaint for workplace harassment?",
      "What protection and shelter exist for domestic violence victims?",
      "How to report police apathy or refusal to file an FIR?",
      "What action can NCW take against cyber stalking and online harassment?",
    ],
    searchPlaceholder:
      "Type your query here or press mic for audio communication",
    apiErrorMessage: "Sorry I cannot understand, please reframe the message.",
    grievanceInfo: `
        <div style="text-align:left; font-size:16px">
          1. RTI matters <br><br>
        2. Matters pending before any Court of Law or Tribunal (subjudice matters)<br><br>
        3. Religious matters<br><br>
        4. Commercial disputes and personal family property disputes not within NCW guidelines<br><br>
        5. Anonymous or pseudonymous complaints without contact details.
        </div>
      `,
    ui: {
      dashboard: "Dashboard",
      lodgeComplaint: "Lodge Complaint",
      logout: "Logout",
      responseSummary: "Response Summary",
      complaintDetails: "Complaint Details",
      category: "Category",
      subCategory: "Sub-Category",
      state: "State",
      district: "District",
      city: "City",
      officeArea: "Office Area",
      department: "Department",
      changeCategory: "Change Complaint Category",
      like: "Like",
      dislike: "Dislike",
      submit: "Submit",
      summary: "Summary",
      voiceResponse: "Voice response",
      successMsg: "Complaint details saved successfully",
      ok: "OK",
      feedback: "Feedback",
      feedbackTitle: "Provide your feedback!",
      feedbackExperience: "How was your overall experience with NCW Sahayika?",
      feedbackSuggestions: "Feedback/Suggestions",
      feedbackPlaceholder: "Write your feedback here...",
      feedbackSuccess: "Feedback submitted successfully!",
      feedbackSubmit: "Submit"
    }
  },

  hi: {
    title: "NCW Sahayika - आपकी डिजिटल AI सहायक",
    suggestedQuestionsText: "सुझाए गए प्रश्न",
    suggestedQuestions: [
      "मेरी कॉर्पोरेट कंपनी में वरिष्ठ अधिकारी द्वारा यौन उत्पीड़न किया जा रहा है और कंपनी की आंतरिक शिकायत समिति (ICC) कोई सुनवाई नहीं कर रही है।",
      "मैं घरेलू हिंसा और दहेज उत्पीड़न की शिकायत कराने पुलिस थाने गई थी, लेकिन ड्यूटी अधिकारी ने एफआईआर दर्ज करने से मना कर दिया और दुर्व्यवहार किया।",
      "हमारे इलाके में बस स्टैंड और सार्वजनिक परिवहन मार्गों पर स्ट्रीट लाइट न होने और सुरक्षा की कमी के कारण महिलाओं के साथ आए दिन छेड़खानी होती है।",
      "हमारी कंपनी महिला कर्मचारियों को बिना किसी सुरक्षा गार्ड या कैब सुविधा के देर रात तक काम करने पर मजबूर कर रही है।",
      "कोई व्यक्ति सोशल मीडिया पर फर्जी आईडी बनाकर मेरी तस्वीरें वायरल करने और मुझे ऑनलाइन परेशान व ब्लैकमेल करने की धमकी दे रहा है।",
      "मेरे ससुराल वाले मुझे घरेलू हिंसा और दहेज के लिए प्रताड़ित कर घर से निकाल रहे हैं, मुझे तुरंत सखी निवास / वन स्टॉप सेंटर में आश्रय की आवश्यकता है।",
      "मेरे एनआरआई पति ने शादी के बाद मुझे विदेश में अकेला छोड़ दिया और सभी दस्तावेज व वित्तीय सहायता रोक दी है।",
    ],
    faqTitle: "अपना प्रश्न पूछें",
    faqScroller:
      "यह सहायक एनसीडब्ल्यू सेवाओं से संबंधित मार्गदर्शन प्रदान करता है और प्रश्नों के उत्तर देता है।",
    botScroller:
      "यह सहायक शिकायत दर्ज करने और पहले से जमा किए गए अनुरोधों की स्थिति की जांच करने का एक सरल तरीका प्रदान करता है।",
    suggestedFAQs: [
      "एनसीडब्ल्यू क्या है?",
      "एनसीडब्ल्यू के क्या अधिकार हैं?",
      "एनसीडब्ल्यू अपनी भूमिका कैसे निभाता है?",
      "कार्यस्थल पर यौन उत्पीड़न (POSH) की शिकायत कैसे दर्ज करें?",
      "घरेलू हिंसा से पीड़ित महिलाओं के लिए क्या सुरक्षा और आश्रय उपलब्ध है?",
      "पुलिस द्वारा एफआईआर दर्ज न करने या दुर्व्यवहार की शिकायत कैसे करें?",
      "साइबर स्टॉकिंग और ऑनलाइन उत्पीड़न पर NCW क्या कार्रवाई करता है?",
    ],
    searchPlaceholder:
      "अपना प्रश्न यहां लिखें या ऑडियो संचार के लिए माइक दबाएं",
    apiErrorMessage:
      "क्षमा करें मैं समझ नहीं पा रहा हूं, कृपया संदेश को फिर से तैयार करें।",
    grievanceInfo: `
        <div style="text-align:left">
          1. आरटीआई मामले <br><br>
        2. किसी भी न्यायालय या न्यायाधिकरण के समक्ष लंबित मामले<br><br>
        3. धार्मिक मामले<br><br>
        4. व्यावसायिक विवाद एवं व्यक्तिगत पारिवारिक संपत्ति विवाद<br><br>
        5. बेनामी या गुमनाम शिकायतें।
        </div>
      `,
    ui: {
      dashboard: "डैशबोर्ड",
      lodgeComplaint: "शिकायत दर्ज करें",
      logout: "लॉग आउट",
      responseSummary: "प्रतिक्रिया सारांश",
      complaintDetails: "शिकायत विवरण",
      category: "श्रेणी",
      subCategory: "उप-श्रेणी",
      state: "राज्य",
      district: "ज़िला",
      city: "शहर",
      officeArea: "कार्यालय क्षेत्र",
      department: "विभाग",
      changeCategory: "शिकायत की श्रेणी बदलें",
      like: "पसंद",
      dislike: "नापसंद",
      submit: "जमा करें",
      summary: "सारांश",
      voiceResponse: "वॉयस प्रतिक्रिया",
      successMsg: "शिकायत विवरण सफलतापूर्वक सहेजा गया",
      ok: "ठीक है",
      feedback: "प्रतिक्रिया",
      feedbackTitle: "अपनी प्रतिक्रिया दें!",
      feedbackExperience: "NCW Sahayika के साथ आपका अनुभव कैसा रहा?",
      feedbackSuggestions: "प्रतिक्रिया/सुझाव",
      feedbackPlaceholder: "यहाँ अपनी प्रतिक्रिया लिखें...",
      feedbackSuccess: "प्रतिक्रिया सफलतापूर्वक जमा की गई!",
      feedbackSubmit: "जमा करें"
    }
  },
};

export default Translation;
